<div style="display: flex;flex-direction: column;align-items: center;
justify-content: center;flex:1;align-self: center;">



  <mat-card style="margin-top: 25px;margin-left: 2%;margin-right: 2%;">
    <!-- <div style="justify-content: center;align-self: center;margin-top: 2%;"> -->
      <span style="font-size: 25px;">{{'Product Improvement for Asset' | translate | async}}</span>

      <button  style="margin-left: 89%; margin-bottom: 1%;" class="button button--primary"><span class="button__text"
        (click)="NavigateToSearch()">{{'Return to Asset Screen' | translate | async}}</span></button>
   
   
    <!-- </div> -->
    <div class="search-options"
      style="min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;height:auto;">



      <mat-form-field class="header-form-full-width">
        <mat-select placeholder="Select Built #" [formControl]="buildnoFormControl"  [(ngModel)]="Selectmodel" multiple required [disabled]="true" >
          <mat-option (click)="selectAll(ev)"    [value]="0"
          #ev
           >{{'Select All' | translate | async}}</mat-option>
          <mat-option [value]="model.ID" *ngFor="let model of modelList" (click)="valueChange(model.ID)" >{{model.modelName}}</mat-option>
        </mat-select>
      </mat-form-field>



      <mat-form-field class="header-form-full-width">
        <mat-label> {{'Serial # Start' | translate | async}}</mat-label>
        <input type="text" matInput placeholder="Enter Serial # Start" [(ngModel)]="serialStart" [disabled]="true">
      </mat-form-field>


      <mat-form-field class="header-form-full-width">
        <mat-label> {{'Serial # End' | translate | async}}</mat-label>
        <input type="text" matInput placeholder="Enter Serial # End" [(ngModel)]="serialEnd" [disabled]="true">
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <mat-label> {{'PIP Number' | translate | async}}</mat-label>
        <input type="text" matInput placeholder="PIP Number" [(ngModel)]="PIPNumber" [disabled]="true">
      </mat-form-field>



      <mat-form-field class="header-form-full-width">
        <mat-label> {{'PIP Heading' | translate | async}}</mat-label>
        <input type="text" matInput placeholder="Enter Heading" [(ngModel)]="PIPHeading" [disabled]="true">
      </mat-form-field>

      <mat-form-field class="header-form-full-width invisible">
        <mat-select name="customer" class="invisible">
        </mat-select>
      </mat-form-field>

        
  <div style="display: flex;" class="sc-row-margin">
    <div style="flex: 1">
      <h4 style="font-size: 14px;" class="get-label">{{'PIP Description' | translate | async}}</h4>     
        <mat-form-field style="width: 1000px;">  
          <textarea class="sc-textarea" matInput [(ngModel)]="PIPDescription" [ngModelOptions]="{standalone: true}" [disabled]="true"></textarea>
        </mat-form-field>    
    </div>
  </div>

  
  <mat-form-field class="header-form-full-width invisible">
    <mat-select name="customer" class="invisible">
    </mat-select>
  </mat-form-field>

      
      <!-- <div style="display: flex;min-width: 30%;height:40px">
       
        <span style="cursor: pointer;font-size: 14px;">Supporting Doc.</span>
          <div *ngFor="let form of attachmentList, let i =  index" style="display: flex;height:40px;justify-content: left;">
            <i style="cursor: pointer;vertical-align: bottom; margin-left: 2%;font-size: 40px;
            color: #3da14b;"
              class="material-icons" class="material-icons" (click)="onClickDownloadForm(form)">description</i>
            <span style=" max-width: 10em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;"><i class="material-icons sc-icon" (click) ="delete(i)">delete</i></span>
          </div>      
          <i   class="material-icons" (click)="openAttachDoc()" style="cursor: pointer;vertical-align: bottom; margin-left: 2%; ">add</i>        
      </div> -->


      <div style="display: flex;min-width: 100%;height:40px;margin-bottom: 2%">
       
        <span style="cursor: pointer;font-size: 14px;">{{'Supporting Doc.' | translate | async}}</span>
          <div *ngFor="let form of PIPSupportDocList, let i =  index" style="display: flex;height:40px;justify-content: left;">
            <i style="cursor: pointer;vertical-align: bottom; margin-left: 10%;font-size: 40px;
            color: #3da14b;"
              class="material-icons" class="material-icons" (click)="onClickDownloadForm(form)" title={{form.FileName}}>description</i>
              <!-- <span style="cursor: pointer;font-size: 13px; max-width: 10em;">{{form}}</span> -->
            <!-- <span style=" white-space: nowrap;"><i class="material-icons sc-icon" (click) ="delete(i)">delete</i></span> -->
            <span style="cursor: pointer;font-size: 13px; max-width: 10em;    overflow-wrap: break-word;">{{form.FileName}}</span>
             <span style=" white-space: nowrap;cursor: pointer" ><i class="material-icons sc-icon" (click)="ReplaceAttachment(form)" title="Replace with New Doc">upgrade</i></span>
            <!-- <i *ngIf="!isGlobal && doc.ShowReplace==true" style="cursor: pointer;vertical-align: bottom; margin-left: 2%; " 
            class="material-icons" (click)="ReplaceAttachment(doc.DocId,attachment)" title="Replace with New Doc">upgrade</i> -->
          </div>      
          <i   class="material-icons" (click)="AddNewAttachment()" style="cursor: pointer;vertical-align: bottom; margin-left: 2%; ">add</i>        
      </div>




      <div style="min-width: 50%;"></div>

      <mat-form-field class="header-form-full-width invisible">
        <mat-select name="customer" class="invisible">
        </mat-select>
      </mat-form-field>


      <mat-form-field class="header-form-full-width">
        <input matInput [matDatepicker]="pickerStart" [(ngModel)]="startDate" [disabled]="true">
        <mat-placeholder>{{'Program Start Date' | translate | async}}</mat-placeholder>
        <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
        <mat-datepicker #pickerStart></mat-datepicker>
      </mat-form-field>


      <mat-form-field class="header-form-full-width">
        <input matInput [matDatepicker]="pickerEnd" [(ngModel)]="endDate" [disabled]="true">
        <mat-placeholder>{{'Program End Date' | translate | async}}</mat-placeholder>
        <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
        <mat-datepicker #pickerEnd></mat-datepicker>
      </mat-form-field>



      <mat-form-field class="header-form-full-width invisible">
        <mat-select name="customer" class="invisible">
        </mat-select>
      </mat-form-field>



      <mat-form-field class="header-form-full-width">
        <mat-select placeholder="Support Pro Associated with PIP" [(ngModel)]="supportProgramAssociateLevel" [disabled]="true">
          <mat-option [value]="level.Id" *ngFor="let level of PIPsupportLevelList"  >{{level.SupportLevel}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <mat-label>{{'Support Program Notes' | translate | async}}</mat-label>
        <input type="text" matInput placeholder="Enter Heading" [(ngModel)]="supportProgramNotes" [disabled]="true">
      </mat-form-field>
      
 
      <mat-form-field class="header-form-full-width invisible">
        <mat-select name="customer" class="invisible">
        </mat-select>
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <mat-select placeholder="Program Status" [(ngModel)]="selectProgramStatus" [disabled]="true">
          <mat-option [value]="status.Id" *ngFor="let status of PIPStatusList" >{{status.Status}}</mat-option>
        </mat-select>
      </mat-form-field>
      
      <mat-form-field class="header-form-full-width">
        <mat-select placeholder="Asset PIP Status" [(ngModel)]="selectAssetPIPStatus">
          <mat-option [value]="1">{{'Open' | translate | async}}</mat-option>
          <mat-option [value]="2">{{'Close' | translate | async}}</mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field class="header-form-full-width">
        <input matInput [matDatepicker]="pipPickerrEnd" [(ngModel)]="pipCompletedDate">
        <mat-placeholder>{{'Date PIP Completed' | translate | async}}</mat-placeholder>
        <mat-datepicker-toggle matSuffix [for]="pipPickerrEnd"></mat-datepicker-toggle>
        <mat-datepicker #pipPickerrEnd></mat-datepicker>
      </mat-form-field>


      <div style="display: flex;" class="sc-row-margin">
        <div style="flex: 1">
          <h4 style="font-size: 14px;" class="get-label">{{'Asset PIP Notes' | translate | async}}</h4>     
            <mat-form-field style="width: 1000px;">  
              <textarea class="sc-textarea" matInput [(ngModel)]="PIPAssetNotes" [ngModelOptions]="{standalone: true}"></textarea>
            </mat-form-field>    
        </div>
      </div>

      <div style="display: flex;" class="sc-row-margin">
        <span style="cursor: pointer;font-size: 14px;">{{'Images' | translate | async}}</span>
          <div class="upload-container" style="height: 40px;" (click)="fileInput.click()"  title="{{'Add photo' | translate | async}}">       
            <i class="material-icons upload-container__icon" style="height: 45px;color: gray;">
              add_a_photo
            </i>
               <input style="display: none;" type="file"
               #fileInput
               (change)="onSelectPhoto($event)">
          </div>
      </div>

      <ng-container *ngFor="let photo of PIPimplementImages">
        <img style="height:50px; padding: 4px; cursor: pointer;" *ngIf="photo" class="component-photo" [src]="sanitize(photo.Images)" (click)="openViewPhoto(photo)"> 
        <!-- <span style=" white-space: nowrap;cursor: pointer" > -->
          <!-- <i class="material-icons sc-icon" (click)="deleteImage(photo)">close</i> -->
        <!-- </span>                    -->
        <!-- <img  (click)="openImage(photo.Id)"
            [src]="getImage(photo.ImageData)" class="component-photo"
            matTooltip="{{photo.Title}}" />                                                -->
        </ng-container>
      

      
      <!-- <div style="min-width: 30%;width: 30%;"></div> -->

      <div style="display: flex;flex-direction: row;justify-content: flex-end;align-self: flex-end;">
      
        <button  style="margin-left: 20px;" class="button button--primary" (click)="addPIPImplementAuditTrail()"><span class="button__text"
            >{{'Update' | translate | async}}</span></button>
      </div>

    </div>
  </mat-card>


  <div  style="width: 100%;">
    <div style="display: flex;min-width: 30%;height:40px; margin-top: 1%;">
      <span style="cursor: pointer;font-size: 17px;margin-left: 2%;"></span>

    </div>

    <table class="table table--full-width table--striped" style="margin-top: 9px;">

      <thead>
        <tr>
          <th style="display: flex;flex-direction: row;justify-content: space-between;">
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'PIP#' | translate | async}}</span>

            </div>           
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'Asset#' | translate | async}}</span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'Model' | translate | async}}
              </span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'Date' | translate | async}}
                
              </span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'Action Description' | translate | async}}</span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'User' | translate | async}}</span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'Old Value' | translate | async}}</span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'New Value' | translate | async}}</span>
            </div>


          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let audit of pipAuditTrailList">
          <td style="min-width: 50px;display: flex;flex-direction: row;justify-content: space-between;">          
            
            <div style="display: flex;flex: 1;justify-content: center;">
              <span (click)="gotoImplementDetailsScreen()"
                style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{PIPId}}</span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span (click)="gotoImplementDetailsScreen()"
                style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{audit.AssetSN}}</span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span (click)="gotoImplementDetailsScreen()"
                style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;"></span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span (click)="gotoImplementDetailsScreen()"
                style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{audit.ModifiedDate  | date:'dd MMM yyyy'}}</span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span (click)="gotoImplementDetailsScreen()"
                style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{audit.Action}}</span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span (click)="gotoImplementDetailsScreen()"
                style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{audit.ModifieUserName}}</span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span (click)="gotoImplementDetailsScreen()"
                style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{audit.oldValue}}</span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span (click)="gotoImplementDetailsScreen()"
                style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{audit.newValue}}</span>
            </div>
           
            
          </td>
        </tr>
      </tbody>
    </table>

    <div style="display: flex;flex-direction: column;align-items: center;
  justify-content: center;min-height: 500px;align-self: center;">
    </div>

  </div>



</div>